import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

// component: (resolve) => require(["@/views/login/index"], resolve),
export var constantRoutes = [{
  path: "/redirect",
  component: Layout,
  hidden: true,
  children: [{
    path: "/redirect/:path*",
    component: function component(resolve) {
      return require(["@/views/redirect"], resolve);
    }
  }]
}, {
  path: "/login",
  component: function component(resolve) {
    return require(["@/views/login"], resolve);
  },
  hidden: true
}, {
  path: "/lockScreen",
  component: function component(resolve) {
    return require(["@/views/basic/lockScreen"], resolve);
  },
  hidden: true
}, {
  path: "/auth-redirect",
  component: function component(resolve) {
    return require(["@/views/login/auth-redirect"], resolve);
  },
  hidden: true
}, {
  path: "/Navigation",
  component: function component() {
    return import("@/views/caf_tms/Navigation/index");
  },
  hidden: true
}, {
  path: "/navigation",
  component: function component() {
    return import("@/views/caf_tms/Navigation/index");
  },
  hidden: true
}, {
  path: "/NavigamoQuery",
  component: function component() {
    return import("@/views/caf_tms/NavigamoQuery/index");
  },
  hidden: true,
  meta: {
    title: "eZ-Freight"
  }
}, {
  path: "/changePassword",
  component: function component() {
    return import("@/views/caf_tms/changePassword/index");
  },
  hidden: true,
  meta: {
    title: "修改密码"
  }
}, {
  path: "/filterCriteria",
  component: function component() {
    return import("@/views/caf_tms/filterCriteria/index");
  },
  hidden: true,
  meta: {
    title: "筛选"
  }
}, {
  path: "/homepagewx",
  component: function component() {
    return import("@/views/caf_tms/homepagewx/index");
  },
  hidden: true,
  meta: {
    title: "首页"
  }
}, {
  path: "/loginwx",
  component: function component() {
    return import("@/views/caf_tms/loginwx/index");
  },
  hidden: true,
  meta: {
    title: "登录"
  }
}, {
  path: "/abnormalFeedback",
  component: function component() {
    return import("@/views/caf_tms/abnormalFeedback/index");
  },
  hidden: true,
  meta: {
    title: "异常反馈"
  }
}, {
  path: "/feedback",
  component: function component() {
    return import("@/views/caf_tms/feedback/index");
  },
  hidden: true,
  meta: {
    title: "反馈详情"
  }
}, {
  path: "/feedbackRecord",
  component: function component() {
    return import("@/views/caf_tms/feedbackRecord/index");
  },
  hidden: true,
  meta: {
    title: "反馈记录"
  }
}, {
  path: "/messageView",
  component: function component() {
    return import("@/views/caf_tms/messageView/index");
  },
  hidden: true,
  meta: {
    title: "消息查看"
  }
},, {
  path: "/orderInquiry",
  component: function component() {
    return import("@/views/caf_tms/orderInquiry/index");
  },
  hidden: true,
  meta: {
    title: "订单查询"
  }
}, {
  path: "/messageDetails",
  component: function component() {
    return import("@/views/caf_tms/messageDetails/index");
  },
  hidden: true,
  meta: {
    title: "消息详情"
  }
}, {
  path: "/NavigationQuery",
  component: function component() {
    return import("@/views/caf_tms/NavigationQuery/index");
  },
  hidden: true,
  meta: {
    title: "eZ-Freight"
  }
}, {
  path: "/NavigationQuerywx",
  component: function component() {
    return import("@/views/caf_tms/NavigationQuerywx/index");
  },
  hidden: true,
  meta: {
    title: "eZ-Freight"
  }
}, {
  path: "/Navigationmobile",
  component: function component() {
    return import("@/views/caf_tms/Navigationmobile/index");
  },
  hidden: true,
  meta: {
    title: "eZ-Freight"
  }
}, {
  path: "/navigationmobile",
  component: function component() {
    return import("@/views/caf_tms/Navigationmobile/index");
  },
  hidden: true,
  meta: {
    title: "eZ-Freight"
  }
}];
var createRouter = function createRouter() {
  return new Router({
    mode: "history",
    // require service support
    // mode: 'history',

    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  var _this = this;
  return originalPush.call(this, location).catch(function (err) {
    if (err && err.name != "NavigationDuplicated") _this.replace("/404");
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;